<template>
    <div>
        <veui-dialog
            title="选择标准形象"
            :open="isAvatarChooseDialogShow"
            :overlay-class="{'avatar-choose-dialog': true}"
            :before-close="handleClick"
        >
            <template>
                <div class="avatar-choose-dialog-content">
                    <div class="avatar-choose-dialog-content-tips">
                        <div class="avatar-choose-dialog-content-tips-icon"></div>
                        {{ isAllReady ? '选择照片作为您的形象，若生成的照片均不符合您的要求，请点击重新生成，再次进行选择。'
                            : '根据您提供的照片，为您AI定制专属职业形象，帮助您提升审核通过率，请耐心等待15秒' }}
                    </div>
                    <div class="pic-list">
                        <div class="left" @click="handleSelect(originImage)">
                            <div
                                class="avatar-img"
                                :class="[isAllReady && selected === originImage ? 'checked' : '']"
                            >
                                <div v-if="originImage" class="img-wrap">
                                    <img
                                        :src="originImage"
                                    />
                                </div>
                            </div>
                            <div v-if="originImage" class="label-icon"></div>
                            <template v-if="isAllReady">
                                <div
                                    v-if="originImage"
                                    :class="['checked-icon', selected === originImage ? 'checked' : '']"
                                ></div>
                            </template>
                            <div
                                v-if="isTimeUseUp || isAllReady || isError" class="upload-img"
                            >
                                <veui-uploader
                                    ref="avatarUploader"
                                    :value="reUploadImages"
                                    :action="`${url}&bucketName=law_smart&storeDir=register_image&ajax=true`"
                                    type="image"
                                    :max-size="maxSize"
                                    :max-count="1"
                                    accept=".jpg,.png,.jpeg"
                                    :convert-response="(data) => convertResponse(data, 'degree_license')"
                                    @change="avatarChange"
                                    @failure="avatarFailure"
                                />
                            </div>
                        </div>
                        <div
                            v-for="item, index in list"
                            :key="index"
                            class="ai-img"
                            :class="{'checked': isAllReady && selected === item, 'time-use-up': isTimeUseUp}"
                            @click="handleSelect(item)"
                        >
                            <!-- 生成失败 -->
                            <div v-if="isError" class="ai-avatar-error">
                                <div class="ai-avatar-error-text">生成失败，建议重新提交或更换照片</div>
                            </div>
                            <div v-else-if="item" class="img-wrap">
                                <img
                                    :src="item"
                                >
                            </div>
                            <template v-else-if="!isTimeUseUp">
                                <img
                                    :src="aiAvatarBg"
                                    class="ai-avatar-bg"
                                >
                                <div class="ai-avatar-create">
                                    <lottie
                                        :id="'ai-avatar-create-' + index" :path="starPath"
                                        :height="48" :width="48"
                                    />
                                    <div class="create-process">{{ progress }}%AI形象生成中</div>
                                    <div class="create-process-tips">定制职业形象更易过审</div>
                                </div>
                            </template>
                            <template v-if="isAllReady">
                                <div v-if="item" class="label-icon"></div>
                                <div v-if="item" :class="['checked-icon', selected === item ? 'checked' : '']"></div>
                            </template>
                        </div>
                    </div>
                </div>
            </template>
            <template #foot>
                <veui-button
                    v-if="isAllReady"
                    ui="l strong"
                    :class="['again-btn', isAllReady ? '' : 'disabled']"
                    @click="handleAgain('again-btn')"
                >
                    <span class="icon"></span>
                    重新生成
                </veui-button>
                <div class="button-right">
                    <veui-button
                        v-if="!isError && !isTimeUseUp && !isAllReady"
                        ui="l strong"
                        class="jump-btn"
                        @click="clickJump"
                    >
                        跳过
                    </veui-button>
                    <veui-button
                        ui="l primary"
                        :class="['next-btn', isError || isTimeUseUp || isAllReady && selected ? '' : 'disabled']"
                        @click="handleNext"
                    >
                        下一步
                    </veui-button>
                </div>
            </template>
        </veui-dialog>
        <confirm-dialog
            ref="confirmDialog"
            title="确定要跳过吗？"
            left-btn-text="跳过"
            right-btn-text="等待生成"
            content="跳过后将直接使用当前照片，若不符合规范可能延长审核"
            type="jump-dialog"
            @ok="handleJump"
        />
    </div>
</template>

<script>

// 上传头像后，ai生成选择弹窗
import {Dialog, Button, Uploader} from 'veui';
import confirmDialog from '../components/confirm-dialog.vue';
import lottie from '@/components/lottie.vue';
import {mapState} from 'vuex';
export default {
    name: 'avatar-choose-dialog',
    components: {
        'veui-dialog': Dialog,
        'veui-button': Button,
        'veui-uploader': Uploader,
        'confirm-dialog': confirmDialog,
        lottie
    },
    props: {
        avatar: {
            type: String,
            default: ''
        },
        // 最原始的头像
        originAvatar: {
            type: String,
            default: ''
        }
    },
    watch: {
        avatar: {
            immediate: true,
            handler(val) {
                if (val) {
                    this.originImage = val;
                    this.getTaskId(val);
                }
            }
        },
        taskId() {
            if (this.taskId) {
                this.stopAiAvatarPolling();
                this.startProgress();
                this.getAiAvatar();
            }
        }
    },
    data() {
        return {
            isAvatarChooseDialogShow: true,
            originImage: '',
            list: ['', ''],
            selected: '',
            reUploadImages: null,
            progress: 0,
            timer: null,
            isRunning: false,
            maxSize: 5242880, // 单位btye, 5M
            setTimeoutId: null,
            taskId: null,
            url: '/bp/api/upload?ajax=1&bdstoken=',
            isTimeUseUp: false, // 免费次数已用完
            submit: false,
            aiAvatarBg: 'https://lvlin-fe-saas.cdn.bcebos.com/lottie/ai-avatar-bg.gif',
            starPath: 'https://lvlin-fe-saas.bj.bcebos.com/lottie/xingxing.json',
            isError: false, // 生成失败
            isAvatarChange: false
        };
    },
    computed: {
        ...mapState({
            userInfo: state => state?.lawStore?.userInfoNew || {}
        }),
        isAllReady() {
            return !!(this.originImage && this.list?.length === 2 && this.list[0] && this.list[1]);
        }
    },
    unmounted() {
        clearInterval(this.timer);
        this.timer = null;
    },
    methods: {
        close() {
            this.$emit('close');
        },
        // 是否更新了头像
        show(isUpdata = true, type) {
            // 重新上传了图片，但是点了关闭没保存，下次进来还用原头像
            if (type === 'last-step') {
                this.isAvatarChooseDialogShow = true;
                return;
            }
            if (isUpdata && this.originImage !== this.avatar || this.isAvatarChange) {
                this.originImage = this.avatar;
                this.getTaskId(this.originImage);
                this.isAvatarChange = false;
            }
            if (this.isError) {
                this.getTaskId(this.originImage);
            }
            this.isAvatarChooseDialogShow = true;
        },
        hide() {
            this.isAvatarChooseDialogShow = false;
        },
        handleClick(type) {
            // 点了x按钮关闭弹窗
            if (type === 'cancel') {
                this.$wywLog.send({
                    serverId: 20062,
                    area: 'x-btn',
                    action: 'click'
                });
                // this.originImage = this.avatar;
                // 原来有头像，点击了认证页头像部分上传了新头像
                if (this.originAvatar && this.originAvatar !== this.avatar) {
                    this.originImage = this.originAvatar;
                    this.close();
                    return;
                }
                if (this.isAvatarChange) {
                    this.close();
                }
                else {
                    this.hide();
                }
            }
        },
        handleSelect(url) {
            if (!this.isAllReady) {
                return;
            }
            this.selected = url;
        },
        // 点击下一步
        handleNext() {
            if (!this.isError && !this.isTimeUseUp && (!this.isAllReady || !this.selected)) {
                return;
            }
            this.$wywLog.send({
                serverId: 20062,
                area: 'next-btn',
                action: 'click'
            });
            this.hide();
            this.$emit('handleNext', {
                url: this.selected || this.originImage,
                isSelectAi: this.selected && this.list.includes(this.selected),
                originAvatar: this.originImage
            });
        },
        clickJump() {
            this.$wywLog.send({
                serverId: 20062,
                area: 'jump-btn',
                action: 'click'
            });
            this.$refs.confirmDialog.open();
        },
        reUploadClick() {
            this.$wywLog.send({
                serverId: 20062,
                area: 'reupload-btn',
                action: 'click'
            });
        },
        handleJump() {
            this.hide();
            this.$emit('handleNext', {url: this.originImage, originAvatar: this.originImage});
        },
        // 重新请求接口生成新的ai图片
        // isUploadAvatar: 0 重新生成
        handleAgain(area, isUploadAvatar = 0) {
            if (isUploadAvatar === 0 && !this.isError && !this.isAllReady) {
                return;
            }
            this.$wywLog.send({
                serverId: 20062,
                area,
                action: 'click'
            });
            this.getTaskId(this.originImage, isUploadAvatar === 0);
        },
        // 重新上传头像
        avatarChange(val) {
            this.isAvatarChange = true;
            if (this.originImage && this.selected === this.originImage) {
                this.selected = val.src;
            }
            this.originImage = val.src || '';
            this.reUploadClick();
            this.handleAgain('', 1);
        },
        avatarFailure(val) {
            if (val.size > this.maxSize) {
                this.$toast.error('上传头像大小不能超过5MB');
                return;
            }
        },
        startProgress() {
            if (this.isRunning) {
                return;
            }

            this.isRunning = true;
            this.progress = 0; // 重置进度为0%
            this.timer = setInterval(() => {
                if (this.progress >= 90) {
                    clearInterval(this.timer); // 到达90%后暂停
                    this.isRunning = false;
                    return;
                }
                this.progress += 1; // 每次增加1%
            }, 100); // 每140ms更新一次（可调整速度）
        },
        /**
         * @param url 头像地址
         * @param isAgain 是否重新生成
         */
        getTaskId(url, isAgain) {
            if (this.submit) {
                return;
            }
            this.submit = true;
            this.$http.post('/bp/avatar/regenavatar', {
                avatar_url: url,
                register_id: this.userInfo?.lawyer_info?.register_id || ''
            }).then(res => {
                this.submit = false;
                if (res && +res.code === 0) {
                    this.taskId = res.data?.task_id;
                    this.list = ['', ''];
                    this.selected = '';
                }
                // 达到每日三次限制，停止轮询
                else if (res && +res.code === 200001) {
                    this.$toast.error(res && res.msg);
                    // 重新生成
                    if (isAgain && this.isAllReady) {
                        this.stopAiAvatarPolling();
                    }
                    else {
                        this.isTimeUseUp = true;
                        this.list = ['', ''];
                        this.selected = '';
                        this.stopAiAvatarPolling();
                    }
                }
                else {
                    this.list = ['', ''];
                    this.selected = '';
                    this.stopAiAvatarPolling();
                    this.$toast.error(res && res.msg || '请求失败，请稍后再试～');
                }
            }).catch(() => {
                this.submit = false;
                this.stopAiAvatarPolling();
                this.$toast.error('提交失败，请稍后再试～');
            }).finally(() => {
                this.pollingStartTime = '';
                this.isError = false;
            });
        },

        getAiAvatar() {
            // 请求接口
            this.$http.get('/bp/avatar/getavatorbytaskid', {
                params: {
                    task_id: this.taskId
                }
            }).then(res => {
                if (res && +res.code === 0) {
                    if (res.data?.avatar_urls && res.data?.avatar_urls.split('$')?.length === 2
                        && res.data?.avatar_urls.split('$')[0] && res.data?.avatar_urls.split('$')[1]) {
                        // 返回结果，停止轮询
                        this.list = res.data?.avatar_urls.split('$');
                        this.selected = this.list[0];
                        this.stopAiAvatarPolling();
                        return;
                    }
                    // 没有结果，继续轮询
                    // 增加轮询时间限制：最多轮询1分钟
                    if (!this.pollingStartTime) {
                        this.pollingStartTime = Date.now();
                    }
                    const elapsed = Date.now() - this.pollingStartTime;
                    if (elapsed < 60000 * 3) { // 1分钟 = 60000毫秒
                        this.setTimeoutId = setTimeout(this.getAiAvatar, 5000); // 5秒后再次请求
                    }
                    else {
                        // 超过1分钟，停止轮询
                        this.stopAiAvatarPolling();
                        this.isError = true;
                    }
                }
                else {
                    this.$toast.error(res && res.msg || '生成失败，请稍后再试～');
                }
            })
                .catch(() => {
                    this.$toast.error('生成失败，请稍后再试～');
                });
        },
        // 停止轮询的方法
        stopAiAvatarPolling() {
            if (this.setTimeoutId) {
                clearTimeout(this.setTimeoutId);
                this.setTimeoutId = null;
            }
        },
        convertResponse(data, key) {
            const {bos_url, name} = data?.data || {};
            return ({
                success: data && (Number(data.code) === 0),
                src: bos_url,
                message: data && data.msg,
                key: name
            });
        }
    }
};
</script>

<style lang="less" scoped>

.avatar-choose-dialog ::v-deep .veui-dialog-content {
    width: 840px;
    border-radius: 8px;

    .veui-dialog-content-foot {
        padding-top: 8px;
        display: flex;
        justify-content: space-between;
        position: relative;
        height: 44px;

        .disabled {
            opacity: .4;
        }

        .again-btn,
        .jump-btn {
            border: 1px solid #1e1f2433;
            color: #1e1f24;
            width: 104px;
            height: 44px;
            font-weight: 500;
            font-size: 16px;
            border-radius: 6px;
        }

        .again-btn {
            width: 124px;

            .icon {
                height: 18px;
                width: 18px;
                margin-right: 6px;
                background: url("https://lvlin-fe-saas.cdn.bcebos.com/material/shuaxin.png") no-repeat center center / 100% 100%;
            }
        }

        .button-right {
            position: absolute;
            right: 24px;
        }

        .next-btn {
            width: 120px;
            height: 44px;
            border-radius: 6px;
            font-family: PingFang SC;
            font-weight: 500;
            font-size: 16px;
            color: #fff;
        }
    }

    .veui-dialog-content-head {
        padding-top: 21px;
        padding-bottom: 20px;

        .veui-dialog-content-head-title {
            line-height: 1;
        }
    }
}

.avatar-choose-dialog-content {
    font-size: 14px;
    color: #282c33;
    letter-spacing: 0;
    line-height: 25px;
    margin-bottom: 16px;

    .avatar-choose-dialog-content-tips {
        border: 1px solid #e0ebff;
        backdrop-filter: blur(27.18px);
        border-radius: 6px;
        height: 34px;
        font-family: PingFang SC;
        font-weight: 400;
        font-size: 14px;
        line-height: 1;
        display: flex;
        align-items: center;
        padding: 0 12px;
        background: #0055ff0d;

        .avatar-choose-dialog-content-tips-icon {
            height: 16px;
            width: 16px;
            margin-right: 8px;
            background: url("https://lvlin-fe-saas.cdn.bcebos.com/material/!.png") no-repeat center center / 100% 100%;
        }
    }

    .pic-list {
        margin-top: 18px;
        display: flex;
        justify-content: space-between;

        .ai-img,
        .avatar-img {
            border: 1px solid #e9ecf3;
            width: 258px;
            height: 258px;
            border-radius: 7px;
            cursor: pointer;

            &.checked {
                border-color: #05f;
            }

            .img-wrap {
                height: 100%;
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: center;

                img {
                    max-height: 100%;
                    max-width: 100%;
                    border-radius: 6px;
                    object-fit: contain;
                }
            }

            .ai-avatar-error {
                height: 100%;
                width: 100%;
                text-align: center;
                background: url("https://lvlin-fe-saas.cdn.bcebos.com/material/spot-image-error.png") no-repeat center / 80px 80px #f5f6f9;
                background-position-x: center;
                background-position-y: 75px;

                .ai-avatar-error-text {
                    color: #848691;
                    font-family: PingFang SC;
                    font-weight: 400;
                    font-style: Regular;
                    font-size: 16px;
                    line-height: 1.2;
                    padding-top: 155px;
                    width: 148px;
                    margin: 0 auto;
                }
            }
        }

        .ai-img {
            position: relative;
            flex-shrink: 0;
            overflow: hidden;

            &.time-use-up {
                border: none;
                background: url("https://lvlin-sp-saas.cdn.bcebos.com/authenticeProcess/time-use-up.png") no-repeat center center / 100% 100%;
            }

            .label-icon {
                position: absolute;
                width: 47px;
                height: 21px;
                top: 8px;
                left: 8px;
                background: url("https://lvlin-fe-saas.cdn.bcebos.com/material/ai.png") no-repeat center center / 100% 100%;
            }

            .ai-avatar-bg {
                position: absolute;
            }

            .ai-avatar-create {
                color: #1e1f24;
                font-size: 13px;
                margin-top: 74px;
                text-align: center;
                line-height: 1;
                position: relative;
                z-index: 1;

                /deep/ .lottie {
                    margin: 0 auto;
                }

                .create-process {
                    color: #1e1f24;
                    font-size: 16px;
                    font-weight: 500;
                    margin-bottom: 12px;
                    margin-top: 18px;
                }

                .create-process-tips {
                    opacity: .7;
                }
            }
        }

        .checked-icon {
            position: absolute;
            width: 21px;
            height: 21px;
            top: 8px;
            right: 8px;
            background: url("https://lvlin-fe-saas.cdn.bcebos.com/material/no-checked.png") no-repeat center center / 100% 100%;

            &.checked {
                background-image: url("https://lvlin-fe-saas.cdn.bcebos.com/material/checked.png");
            }
        }

        .left {
            position: relative;

            .label-icon {
                position: absolute;
                width: 60px;
                height: 21px;
                top: 8px;
                left: 8px;
                background: url("https://lvlin-fe-saas.cdn.bcebos.com/material/zuozhe.png") no-repeat center center / 100% 100%;
            }

            .upload-img {
                position: absolute;
                width: 36px;
                height: 36px;
                left: 8px;
                bottom: 8px;
                cursor: pointer;
                background: url("https://lvlin-fe-saas.cdn.bcebos.com/material/shangchuan-icon.png") no-repeat center center / 100% 100%;

                /deep/ .veui-uploader {
                    height: 100%;
                    width: 100%;
                    opacity: 0;

                    .veui-uploader-list-media-container,
                    .veui-uploader-media {
                        height: 100%;
                        width: 100%;
                    }

                    .veui-uploader-list-media-item {
                        width: 36px;
                        height: 36px;
                    }
                }
            }
        }
    }
}
</style>
